import React, { useEffect, useState } from "react";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Common_Report_Offcanvas from "../../common_report_offcanvas/Common_Report_Offcanvas";
import { Nav, Tab } from "react-bootstrap";
import Use_Of_Reference_Material from "./inner_tab_reports/use_of_reference_material/Use_Of_Reference_Material";
import Use_Of_Alternative_Instrument from "./inner_tab_reports/use_of_alternative_instrument/Use_Of_Alternative_Instrument";
import Replicate_Testing from "./inner_tab_reports/replicate_testing/Replicate_Testing";
import Retesting_Testing from "./inner_tab_reports/retesting_testing/Retesting_Testing";
import Blind_Sample from "./inner_tab_reports/blind_sample/Blind_Sample";
import ILC from "./inner_tab_reports/ilc/ILC";
import PT_Report from "./inner_tab_reports/pt_report/PT_Report";
import { useDispatch, useSelector } from "react-redux";
import {
  GetSampleReport,
  GetValidityReport,
} from "../../../../../features/admin/report_generator/Slice";
import { GetAll } from "../../../../../../src/features/admin/quality_management/process_requirement/validity/Slice";
import { allTestType } from "../../../../../features/admin/common/Slice";

const Ensuring_Validity_Of_Result = () => {
  const [show, setShow] = useState(false);

  const VALIDITY_TYPE_MAP = {
    Use_Reference_Material: 1,
    Use_Alternative_Instrument: 2,
    Replicate_Testing: 3,
    Retesting_Testing: 4,
    Blind_Sample: 5,
    ILC: 6,
    PT: 7,
  };

  const dispatch = useDispatch();
  const validitydetails = useSelector((state) => state.validity);

  const [currentPage, setCurrentPage] = useState(1);
  const [activeValidityTypeId, setActiveValidityTypeId] = useState(1);
  const [searchParams, setSearchParams] = useState({
    start_date: "",
    end_date: "",
    test_type_id: "",
  });
  const fetchRecords = async (
    page = 1,
    validityTypeId = activeValidityTypeId,
  ) => {
    await dispatch(
      GetAll({
        page,
        per_page: validitydetails.per_page,
        validity_type_id: validityTypeId,
        start_date: searchParams?.start_date,
        end_date: searchParams?.end_date,
        test_type_id: searchParams?.test_type_id?.value,
      }),
    );
  };

  useEffect(() => {
    fetchRecords(currentPage);
  }, [activeValidityTypeId, currentPage, searchParams]);

  const [showLottie, setShowLottie] = useState(true);
  const [reportPath, setReportPath] = useState("");
  const [name, setName] = useState("");
  const reportgenerate = async (name) => {
    setName(name);
    setShow(true);
    setShowLottie(true);
    const response = await dispatch(
      GetValidityReport({
        validity_type_id: activeValidityTypeId,
        name: name,
        start_date: searchParams?.start_date,
        end_date: searchParams?.end_date,
        test_type_id: searchParams?.test_type_id?.value,
      }),
    );

    if (response?.meta?.requestStatus === "fulfilled") {
      const path = response?.payload?.path;
      setReportPath(path);
      setShowLottie(false);
    } else {
      setShowLottie(false); // also stop loader on error
    }
  };

  useEffect(() => {
    dispatch(allTestType());
  }, [dispatch]);

  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Ensuring Validity Of Result" />
      </div>

      <div className="tables_tab_section">
        <Tab.Container
          defaultActiveKey="Use_Reference_Material"
          onSelect={(key) => {
            const validityTypeId = VALIDITY_TYPE_MAP[key];
            setActiveValidityTypeId(validityTypeId);
            setCurrentPage(1);
            fetchRecords(1, validityTypeId);
          }}
        >
          <Nav variant="pills">
            <Nav.Item>
              <Nav.Link eventKey="Use_Reference_Material">
                Use Of Reference Material
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="Use_Alternative_Instrument">
                Use Of Alternative Instrument
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="Replicate_Testing">
                Replicate Testing
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="Retesting_Testing">
                Retesting Testing
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="Blind_Sample">Blind Sample</Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="ILC">Inter laboratory Comparison</Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="PT">Proficiency Testing</Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content className="inner-tab-sec">
            <Tab.Pane eventKey="Use_Reference_Material">
              <Use_Of_Reference_Material
                setSearchParams={setSearchParams}
                reportgenerate={reportgenerate}
                validitydetails={validitydetails}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
              />
            </Tab.Pane>

            <Tab.Pane eventKey="Use_Alternative_Instrument">
              <Use_Of_Alternative_Instrument
                setSearchParams={setSearchParams}
                reportgenerate={reportgenerate}
                validitydetails={validitydetails}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
              />
            </Tab.Pane>

            <Tab.Pane eventKey="Replicate_Testing">
              <Replicate_Testing
                setSearchParams={setSearchParams}
                reportgenerate={reportgenerate}
                validitydetails={validitydetails}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
              />
            </Tab.Pane>

            <Tab.Pane eventKey="Retesting_Testing">
              <Retesting_Testing
                setSearchParams={setSearchParams}
                reportgenerate={reportgenerate}
                validitydetails={validitydetails}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
              />
            </Tab.Pane>

            <Tab.Pane eventKey="Blind_Sample">
              <Blind_Sample
                setSearchParams={setSearchParams}
                reportgenerate={reportgenerate}
                validitydetails={validitydetails}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
              />
            </Tab.Pane>

            <Tab.Pane eventKey="ILC">
              <ILC
                setSearchParams={setSearchParams}
                reportgenerate={reportgenerate}
                validitydetails={validitydetails}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
              />
            </Tab.Pane>

            <Tab.Pane eventKey="PT">
              <PT_Report
                setSearchParams={setSearchParams}
                reportgenerate={reportgenerate}
                validitydetails={validitydetails}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
              />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
        {/* <Tab.Container id="left-tabs-example" defaultActiveKey={tabs[0]}>
          <Nav variant="pills" className="">
            {tabs?.map((item) => {
              return (
                <Nav.Item>
                  <Nav.Link eventKey={item}>{item}</Nav.Link>
                </Nav.Item>
              );
            })}
          </Nav>

          <Tab.Content className="inner-tab-sec">
            <Tab.Pane eventKey="Use Of Reference Material">
              <Use_Of_Reference_Material />
            </Tab.Pane>

            <Tab.Pane eventKey="Use Of Alternative Instrument">
              <Use_Of_Alternative_Instrument />
            </Tab.Pane>

            <Tab.Pane eventKey="Replicate Testing">
              <Replicate_Testing />
            </Tab.Pane>

            <Tab.Pane eventKey="Retesting Testing">
              <Retesting_Testing />
            </Tab.Pane>

            <Tab.Pane eventKey="Blind Sample">
              <Blind_Sample />
            </Tab.Pane>

            <Tab.Pane eventKey="ILC">
              <ILC />
            </Tab.Pane>

            <Tab.Pane eventKey="PT">
              <PT_Report />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container> */}
      </div>

      <Common_Report_Offcanvas
        reportPath={reportPath}
        reportgenerate={reportgenerate}
        setShowLottie={setShowLottie}
        showLottie={showLottie}
        title={name || "Resource Requirement"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Ensuring_Validity_Of_Result;
